import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const Location = namespace('locations');

@Component
export default class FetchLocations extends Vue {
    @Location.Action('fetch')
    private fetchLocations!: () => Promise<void>;

    async created(): Promise<void> {
        await this.fetchLocations();
    }
}
